module.exports = __webpack_public_path__ + "media/components/journeys/ticket-icons/rest-stop-cc0c231351deff197b94fb11f35d32d5.png";